/* eslint-disable new-cap */
import React, { useContext } from 'react';
import I18n from 'i18n-js';
import { FetchResult } from '@apollo/client';
import { RCButton } from '@reverbdotcom/cadence/components';
import {
  core_apimessages_ListingStateUpdate,
} from '@reverbdotcom/commons/src/rql';
import SellerListingCardContext from '../SellerListingCardContext';
import { ActionType } from '../sellerListingCardReducer';
import refetchCardListing from '../refetchCardListing';

interface IMutationError {
  extensions: {
    errors: [{
      message: string
    }]
  },
}

type IExtendedMutationResult<TData> = FetchResult<TData> & {
  errors?: IMutationError[]
};

function ListingRowEndButton({ updateListingState }) {
  const listingCardContext = useContext(
    SellerListingCardContext,
  );

  const { cardState, dispatch } = useContext(
    SellerListingCardContext,
  );

  async function startEndListing() {
    dispatch({
      type: ActionType.SET_LOADING_LISTING,
      payload: {
        loadingListing: true,
      },
    });

    try {
      const res = await updateListingState({
        variables: {
          input: {
            productId: cardState.listing.id,
            newState: core_apimessages_ListingStateUpdate.ENDED,
          },
        },
      }) as IExtendedMutationResult<typeof updateListingState>;

      const { hasErrors } = checkResponse(res);

      if (hasErrors) {
        const [userError] = formatErrors(res.errors);

        dispatch({
          type: ActionType.SET_LOADING_LISTING,
          payload: {
            loadingListing: false,
          },
        });

        dispatch({
          type: ActionType.SHOW_TOAST,
          payload: {
            isSuccess: false,
            message: userError?.message,
          },
        });
      } else {
        dispatch({
          type: ActionType.SHOW_TOAST,
          payload: {
            isSuccess: true,
            message: I18n.t(
              'discovery.listingsManagement.sellerListingCard.endSuccess',
            ),
          },
        });
        
        refetchCardListing(listingCardContext);
      }
    } catch (error) {
      dispatch({
        type: ActionType.SET_LOADING_LISTING,
        payload: {
          loadingListing: false,
        },
      });
      dispatch({
        type: ActionType.SHOW_TOAST,
        payload: {
          isSuccess: false,
          message: I18n.t(
            'discovery.listingsManagement.genericError',
          ),
        },
      });
    }
  }

  function checkResponse(
    res,
  ) {
    return {
      hasErrors: !!res.errors?.length,
      hasData: !!res.data,
    };
  }

  function formatErrors(errors) {
    return errors[0]?.extensions?.errors || [];
  }

  return (
    <>
      <RCButton
        onClick={startEndListing}
        variant="outlined"
        fullWidth
      >
        {I18n.t('discovery.listingsManagement.sellerListingCard.end')}
      </RCButton>
    </>
  );
}

export default ListingRowEndButton;
